export default [
  { Code: 1, DisplayName: "One Time", PaymentDisplayName: "SINGLE" },
  { Code: 2, DisplayName: "Two Times", PaymentDisplayName: "TWO" },
  { Code: 3, DisplayName: "Three Times", PaymentDisplayName: "THREE" },
  { Code: 4, DisplayName: "Four Times", PaymentDisplayName: "FOUR" },
  { Code: 5, DisplayName: "Five Times", PaymentDisplayName: "FIVE" },
  { Code: 6, DisplayName: "Six Times", PaymentDisplayName: "SIX" },
  { Code: 100, DisplayName: "Multiple Times", PaymentDisplayName: "MULTI" }
];



// WEBPACK FOOTER //
// ./src/config/ListUsage.js